if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      this.cartNotification.setActiveElement(document.activeElement);

      const submitButton = this.querySelector('[type="submit"]');

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      let hasExtraItem;

      const addAllItems = function() {

        var atcBtn = document.querySelectorAll('[data-extra-item-selected-variant]');
        var product_data = new Array();
        
        atcBtn.forEach(function (variant) {
          if (variant.value !== '') {
            product_data.push({ quantity: 1, id: variant.value });
          }
        });

        if (product_data.length > 0 ) {
          // add the items to the data object we need to pass to the fetch call 
          var data = {
            items: product_data
          }
                
          fetch('/cart/add.js', {
            body: JSON.stringify(data),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With':'xmlhttprequest'
            },
            method: 'POST'
          }).then((response) => {
            return response.json();
          }).then((json) => {
            /* yay! our products were added - do something here to indicate to the user */
            window.location.href = '/cart';
          }).catch((err) => {
            /* uh oh, we have error. */
            console.error(err)
          });
        } else {
          hasExtraItem = false;
        }
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cartNotification) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;

      // const body = JSON.stringify({
      //   ...JSON.parse(serializeForm(this.form)),
      //   sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      //   sections_url: window.location.pathname
      // });

      // fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          this.cartNotification.renderContents(parsedState);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
  });
}
